var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("width:" + _vm.dispW + "px;height:" + _vm.dispH + "px;margin:0 auto"))},[_c('div',{staticStyle:{"width":"104%","position":"relative","left":"-13px"}},[_c('h1',{staticClass:"manualtitle"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{ref:"trend",staticClass:"wrapper-full"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2584e9a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/dryeye/components/basic/ButTrend.vue
// module id = null
// module chunks = 